// @flow

import React, { Fragment, useState, useEffect } from 'react';
import { Card, CardContent, Tabs, Tab, Typography, Box, TextField } from '@material-ui/core';
import { required, minLength, maxLength, minValue, maxValue, number, regex, email, choices } from 'react-admin';
import { SelectInput, TextInput, DateTimeInput, TabbedForm, FormTab, TabbedFormTabs } from 'react-admin';
import { useDataProvider, Loading, Error, useNotify, useTranslate, FormDataConsumer } from 'react-admin';
import { translations } from '../../i18n/i18n';
import ConfigGeneral from '../../config/general';

const Settings = () => {
	const dataProvider = useDataProvider();
	const notify = useNotify();
	const translate = useTranslate();
	const [settings, setSettings] = useState();
	const [loading, setLoading] = useState(true);
	const [saving, setSaving] = useState(false);
	const [error, setError] = useState();
	useEffect(() => {
		dataProvider.getOne('settings', {})
			.then(({ data }) => {
				setSettings(data);
				setLoading(false);
			})
			.catch(error => {
				setError(error);
				setLoading(false);
			});
	}, []);

	const saveSettings = (data) => {
		setSaving(true);
		dataProvider.update('settings', { id: 0, data })
			.then(({ data }) => {
				setSettings(data);
				setSaving(false);
				notify(translate('ra.notification.updated', {smart_count: 1}));
			})
			.catch(error => {
				setError(error);
				setSaving(false);
			});
	};

	if (loading) return <Loading />;
	if (error) return <Error />;

	return (
		<Fragment>
			<h2>{translate('resources.settings.name')}</h2>
			<Card>
				<CardContent>
					<TabbedForm variant="standard" tabs={<TabbedFormTabs variant="scrollable" />} resource="settings" record={settings} save={saveSettings} saving={saving}>
						{ConfigGeneral.locales.map(locale => <FormTab label={locale.name}>
							<TextInput source={`page_title_${locale.code}`} label={translate('resources.settings.fields.page_title')} validate={[maxLength(255)]} fullWidth />
							<TextInput source={`sidebar_title_${locale.code}`} label={translate('resources.settings.fields.sidebar_title')} validate={[maxLength(255)]} fullWidth />
							<TextInput source={`sidebar_text_${locale.code}`} label={translate('resources.settings.fields.sidebar_text')} validate={[maxLength(255)]} fullWidth multiline />
							<TextInput source={`footer_text_${locale.code}`} label={translate('resources.settings.fields.footer_text')} validate={[maxLength(255)]} fullWidth />
							<TextInput source={`impressum_${locale.code}`} label={translate('resources.settings.fields.impressum')} validate={[maxLength(255)]} fullWidth multiline />
						</FormTab>)}
					</TabbedForm>
				</CardContent>
			</Card>
		</Fragment>
	);
};

export default Settings;